export default {"src":"/_next/static/media/exclamation_triangle.55c00472.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};